import type { IExercise } from '../exercises';

export const FOUR_WAY_EPISODE_04_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-four-way-04-01",
    "name": "弹力带肩部前后拉",
    "bodyPart": "warmup",
    "equipment": "resistance-band",
    "subCategory": "shoulder",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "15",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": false,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["全身激活肌群"],
    "demoUrl": "/media/collections-20261008/demos/mobile-dee6c79d19d1439c8fa3f6fc.mp4",
    "videoUrl": "/media/collections-20261008/videos/9cd4695c6593b29f4cfe5cbe.mp4",
    "source": "四分化训练 · 第4期",
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-02",
    "name": "俯卧撑",
    "bodyPart": "chest",
    "equipment": "bodyweight",
    "subCategory": "mid-chest",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "力竭",
    "rpe": 9,
    "restSeconds": 60,
    "isBodyweight": true,
    "difficulty": "advanced",
    "targetMuscles": ["胸大肌", "三角肌前束"],
    "demoUrl": "/media/collections-20261008/demos/mobile-511a8715bd777423df6ea4c6.mp4",
    "videoUrl": "/media/collections-20261008/videos/52ae225c04f4b1f33940768e.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-03",
    "name": "俯卧哑铃飞鸟",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束", "斜方肌下部"],
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "mediaIssue": "新文件为徒手肩胛激活，俯卧哑铃飞鸟素材待补齐",
    "demoStatus": "pending",
  },
  {
    "id": "course-20261008-four-way-04-04",
    "name": "站姿杠铃推举",
    "bodyPart": "shoulders",
    "equipment": "barbell",
    "subCategory": "front-deltoid",
    "tips": ["核心收紧", "推举至头顶"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-cb671e0f6dc39335d23d63c0.mp4",
    "videoUrl": "/media/collections-20261008/videos/7668312aedc7324bf74b0120.mp4",
    "targetMuscles": ["三角肌前束", "三角肌中束", "肱三头肌"],
    "difficulty": "intermediate",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-05",
    "name": "哑铃前平举",
    "bodyPart": "shoulders",
    "equipment": "dumbbell",
    "subCategory": "front-deltoid",
    "tips": ["前平举刺激前束", "交替或双手"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-76b72f26651787bf536ffab6.mp4",
    "videoUrl": "/media/collections-20261008/videos/e277691c1cc21f0da86d73f9.mp4",
    "targetMuscles": ["三角肌前束"],
    "difficulty": "intermediate",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-06",
    "name": "坐姿反飞鸟",
    "bodyPart": "shoulders",
    "equipment": "machine",
    "subCategory": "rear-deltoid",
    "tips": ["肩胛骨后缩", "感受后束收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-56be852ba5c5484a64a65bf4.mp4",
    "videoUrl": "/media/collections-20261008/videos/17f584ca8054744b9d4a9296.mp4",
    "targetMuscles": ["三角肌后束"],
    "difficulty": "beginner",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-07",
    "name": "绳索面拉",
    "bodyPart": "shoulders",
    "equipment": "cable",
    "subCategory": "rear-deltoid",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["三角肌后束", "斜方肌下部"],
    "demoUrl": "/media/collections-20261008/demos/mobile-e6aa2454ae1700f17e8657f7.mp4",
    "videoUrl": "/media/collections-20261008/videos/720e058ee1c739a2ef4b720c.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-08",
    "name": "坐姿绳索二头弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-9cc5a0b00bc0cbb41d2e6c40.mp4",
    "videoUrl": "/media/collections-20261008/videos/reviewed-a780e663ad8a95104c7b3a42.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-09",
    "name": "仰卧绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-d424c0b10ad133347af21546.mp4",
    "videoUrl": "/media/collections-20261008/videos/b710afb5a1a7881a77f4aa37.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-10",
    "name": "颈后绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-016c52ebefdbb149e0663fd1.mp4",
    "videoUrl": "/media/collections-20261008/videos/29e448c7d4d98086922d4b5f.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-04-11",
    "name": "单腿哑铃硬拉",
    "bodyPart": "legs",
    "equipment": "dumbbell",
    "subCategory": "hamstrings",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "每侧10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["腘绳肌", "臀大肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-cf41fc93a2b08783eb89a59c.mp4",
    "videoUrl": "/media/collections-20261008/videos/3813126c85405be32f37cf94.mp4",
    "source": "四分化训练 · 第4期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
